export interface User {
   name: string
   role?: UserRoleEnum
}

export enum UserRoleEnum {
   BASE,
   ADMIN,
}
